import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    const setCookie = function (name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    const getCookie = function (name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function Footer() {
        this.initLangDropdown();
        this.initNewsletterForm();
        this.initCookiePopup();
    }

    Footer.prototype.initLangDropdown = function () {
        const langButton = document.querySelector('.footer .lang-button');
        if (langButton !== null) {
            langButton.addEventListener('click', function (element) {
                const langDropdown = document.querySelector('.footer .lang-dropdown');
                if (langDropdown !== null) {
                    langButton.classList.toggle('active');
                    langDropdown.classList.toggle('active');
                }
            });
        }
    };

    Footer.prototype.initCookiePopup = function () {
        if (getCookie('cookie_consent_popup') === undefined) {
            $('.cookie-consent-widget-container').fadeIn("slow");
        }

        $('.cookie-consent-widget-container .button').click(function(e) {
            e.preventDefault();
            $('.cookie-consent-widget-container').fadeOut("slow", function(){
                setCookie('cookie_consent_popup', 1);
                $(this).remove();
            });
        });
    };

    Footer.prototype.initNewsletterForm = function () {
        const subscribe_hide_days = parseInt($('#subscribe_hide_days').val()),
            delay = parseInt($('#subscribe_delay').val());

        setTimeout(function() {
            $('.subscribe-image-popup').fadeIn('slow');
        }, delay * 1000);

        $('.subscribe-image-popup .close').click(function(e) {
            e.preventDefault();
            $(this).parents('.subscribe-image-popup').fadeOut("slow", function(){
                setCookie('subscribe_popup', 1, subscribe_hide_days);
                $(this).remove();
            });
        });

        $('.footer .newsletter-submit').on('click', function () {
            const email = $('.footer .newsletter-field').val();
            const url = $(this).data('url');

            $.ajax({
                url: url,
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {email: email},
                success: function (response) {
                    new Message(response.message, response.status === 'success' ? 'success' : 'error');
                    $('.footer .newsletter-field').val('');
                }
            });
        });

        $('.subscribe-submit').on('click', function () {
            const email = $('#subscribe-email').val();
            const url = $(this).data('url');

            $.ajax({
                url: url,
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {email: email},
                success: function (response) {
                    new Message(response.message, response.status === 'success' ? 'success' : 'error');

                    if (response.status === 'success') {
                        const subscribe_hide_days_after_subscribe = parseInt($('#subscribe_hide_days_after_subscribe').val());

                        $('#subscribe-popup').fadeOut("slow", function () {
                            setCookie('subscribe_popup', 1, subscribe_hide_days_after_subscribe);
                            $('#subscribe-email').val('');
                        });
                    }
                }
            });
        });
    };

    return Footer;
}(window, document));

